//for ReviewTabChooseChecklist
import { extractActivityButtons } from './ConstActivityBtns';
import { PLATFORM_BUTTONS } from './ConstPlatformBtns';
import { ENVIRONMENT_BUTTONS } from './ConstEnvironmentBtns';
import { POSITION_BUTTONS } from './ConstBodyPositionBtns';
import { IMPORTANCE_BUTTONS } from './ConstImportanceBtns';

export const CHECKLIST_BUTTONS = [ 
  {
    value: 'priority',
    label: 'Will help me perform my Priority Activity',
    moreInfo: '',
    lookup: extractActivityButtons()
  },
  {
    value: 'platforms',
    label: 'Will allow me to use my desired devices',
    moreInfo: '',
    lookup: PLATFORM_BUTTONS
  },
  {
    value: 'environments',
    label: 'Will work properly in my environments',
    moreInfo: '',
    lookup: ENVIRONMENT_BUTTONS
  },
  {
    value: 'bodyPositions',
    label: 'Will allow me to use in needed body positions',
    moreInfo: '',
    lookup: POSITION_BUTTONS
  },
  {
    value: 'indepSetup',
    label: 'Can be set up and used at my desired level of independence and with my available support',
    moreInfo: '',
    lookup: IMPORTANCE_BUTTONS
  },
];

